import corporateRequest from 'utils/corporateRequest'
import authRequest from 'utils/authRequest'
import studentRequest from 'utils/studentRequest'

export const setOfferList = data => {
  return {
    type: 'SET_OFFER_LIST',
    data,
  }
}

export const setSingleOfferDetail = data => {
  return {
    type: 'SET_SINGLE_OFFER_DETAIL',
    data,
  }
}

export const setOfferMetrics = data => {
    return {
      type: 'SET_OFFER_METRICS',
      data,
    }
  }
  

export const getOfferList =
  ({ page, filter, setLoading }) =>
  async (dispatch, getState) => {
    setLoading(true)

    let filterKey = filter ? `&status=${filter ==='ACCEPTED' ? 'ACCEPTED,JOINED' : filter}` : ''
    let pageKey = `&currentPage=${page}`

    const state1 = getState()
    try {
      const res = await corporateRequest.get(
        `/corporates/student/${state1?.auth?.studentId}/OfferList?pageLimit=10${filterKey}${pageKey}`
      )
      dispatch(setOfferList(res?.data?.data))
      setLoading(false)
      console.log('Offer list data fetched successfully')
    } catch (error) {
      console.log('Error in Getting Offer list', error)
    }
  }

  export const getOfferMetric =
  () =>
  async (dispatch, getState) => {

    const state1 = getState()
    try {
      const res = await corporateRequest.get(
        `/corporates/student/${state1?.auth?.studentId}/offerMatrics`
   
      )
      dispatch(setOfferMetrics(res?.data?.data))
      console.log('Offer letter metrics data fetched successfully')
    } catch (error) {
      console.log('Error in Getting Offer letter metrics', error)
    }
  }

export const OfferAcceptReject =
  (data, isApplied) => async (dispatch, getState) => {
    const state = getState()
    const payload = {
      isAccept: isApplied,
    }
    let setStatus = isApplied ? "ACCEPTED" : "REJECTED"  
    try {
      const result = await corporateRequest.post(
        `/corporates/role/${data?.roleId}/student/${state?.auth?.studentId}/offerAcceptReject`,
        payload
      )
      if (result?.status >= 200 && result?.status <= 300) {
        let rolesCopy = { ...state?.offerLetterData?.offerList }
    let index = rolesCopy?.result.findIndex(val => data.id === val.id)
    if (index != -1) {
      if (rolesCopy?.result[index]) {
        rolesCopy.result[index].jobRoleStudentMap.offerStatus = setStatus
   
          dispatch(setOfferList(rolesCopy))
      }
    }

     
      }
      return result
    } catch (error) {
      console.log('Error in Offer Accpect Or Reject =>', error?.message)
      return error?.response
    }
  }


  export const getUserCorpList =
  ( corpId ) =>
  async (dispatch, getState) => {
      try {

        const response = await authRequest.get(
          `/user?coporateId=${corpId}`
        )
    
        return response?.data?.data
      } catch (error) {
        console.log(
          'Getting error in user list',
          error?.response?.data?.message
        )
        return error
      }
  }


  export const OfferAcceptExp =
  (roleId, driveId,payload ) => async (dispatch, getState) => {
    const state = getState()

    try {
      const result = await corporateRequest.post(
        `/corporates/role/${roleId}/drive/${driveId}/student/${state?.auth?.studentId}/offerAcceptReject`,
        payload
      )
      return result
    } catch (error) {
      console.log('Error in Offer Accpect Or Reject =>', error?.message)
      return error?.response
    }
  }


  export const SingleOffer =
  (offerID) => async (dispatch, getState) => {

    try {
      const result = await corporateRequest.get(
        `/corporates/student/offer/${offerID}`
      )
      return result 
    } catch (error) {
      console.log('Error in Offer details =>', error?.message)
      return error?.response
    }
  }


  export const OfferNegotiate =
  (roleId, driveId,payload ) => async (dispatch, getState) => {
    const state = getState()

    try {
      const result = await corporateRequest.post(
        `corporates/role/${roleId}/drive/${driveId}/student/${state?.auth?.studentId}/offerNegotiation`,
        payload
      )
      return result
    } catch (error) {
      console.log('Error in Offer Accpect Or Reject =>', error?.message)
      return error?.response
    }
  }

  export const getCorporateRequestDoc =
  (corpID, driveID, roleID) => async (dispatch, getState) => {
    const state = getState()

    try {
      const result = await corporateRequest.get(
        `/corporates/${corpID}/drive/${driveID}/role/${roleID}/candidate/${state?.auth?.studentId}/reqDocs`
      )
      console.log(result)
      return result
    } catch (error) {
      console.log('Error in Offer details =>', error?.message)
      return error?.response
    }
  }

  
  export const getStudentDocumentList =
  () => async (dispatch, getState) => {
    const state = getState()

    try {
      const result = await studentRequest.get(
        `/students/document/${state?.auth?.studentId}`
      )
      console.log(result)
      return result
    } catch (error) {
      console.log('Error in Offer details =>', error?.message)
      return error?.response
    }
  }

  export const uploadDocumentRequested =
  (payload,navigate) => async (dispatch, getState) => {

  
    try {
      const result = await studentRequest.post(
        `/students/document`,
        payload
      )
      if (result?.status >= 200 && result?.status <= 300) {
   
     navigate('/offerReceived')
      }
      return result
    } catch (error) {
      console.log('Error in Document Upload =>', error?.message)
      return error?.response
    }
  }

  export const candidateJoined = (roleId , driveId) => async (dispatch, getState) => {
    const state = getState()
  let payload = {
    status:'JOINED'
  }
   
    try {
      const result = await corporateRequest.patch(
        `/corporates/role/${roleId}/drive/${driveId}/student/${state?.auth?.studentId}/offerStatus`,payload
      )
      if (result?.status >= 200 && result?.status <= 300) {
        let rolesCopy = { ...state?.offerLetterData?.offerList }
        let index = rolesCopy?.result.findIndex(val => roleId === val.roleId)
        if (index != -1) {
          if (rolesCopy?.result[index]) {
            rolesCopy.result[index].driveRoleCandidateMap.offerStatus = 'JOINED'
       
              dispatch(setOfferList(rolesCopy))
          }
        }
     
      }
      
      return result
    } catch (error) {
      console.log('Error in Document Upload =>', error?.message)
      return error?.response
    }
  }